// @ vendors
import React from 'react';
import PropTypes from 'prop-types';
// @ utilities
import { FormattedText } from 'core/i18n';
// @ constants
import { EVENT_DETAIL_LEGAL_INFO } from 'constants/uTagConstants/RAConstants';

export const GdprLink = ({ recordEvent }) => {
    return (
        <div className="suitability-test__gdpr-consents">
            <div className="suitability-test__gdpr-consents__icon">
                <i className="icons icons--icon-info-blue"></i>
            </div>
            <div className="suitability-test__gdpr-consents__text">
                <FormattedText value="suitabilityTest-gdprText" />
                <p>
                    <FormattedText value="suitabilityTest-gdprText2" />
                    <span className="link-wrapper" onClick={() => recordEvent(EVENT_DETAIL_LEGAL_INFO)}>
                        <FormattedText value="suitabilityTest-gdprLink" />
                    </span>
                </p>
            </div>
        </div>
    );
};

GdprLink.propTypes = {
    recordEvent: PropTypes.func,
};
